module.exports = __webpack_public_path__ + "static/img/jinggangshan.4d89b43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/jinggangshan.png
// module id = VrPA
// module chunks = 1